<template>
  <div class="login-form-wrap">
    <form class="login-form" v-on:submit.prevent>
      <input type="text" placeholder="team name" v-model="name" />
      <input type="email" placeholder="email address" v-model="email" />
      <p>Enter your team name and email address above first!</p>
      <button v-on:click="setContactInfo">start playing</button>
      <p><strong>Da Rules:</strong>  We’re all adults here. Play fair, please don't share answers, search for the answers, or otherwise cheat.</p>
      <p>This trivia is a little different... I'll sing and play part of a song and you name the song, the artist or I may ask you to finish the lyric:)  If you need to hear me play the song again, I will repeat it up to 2 more times. IN THE EVENT OF A TIE, I WILL PLAY TIEBREAKER SONGS TILL SOMEONE WINS.</p>
    </form>
  </div>
</template>

<script>
export default {
  name: 'LoginForm',
  data: function() {
    return {
      name: '',
      email: ''
    }
  },
  methods: {
    setContactInfo: function() {

      if(this.name == '') { 
        alert('Enter a name'); 
        return false; 
      }
      else if(this.email == '') { 
        alert('Enter your email address'); 
        return false; 
      }

      this.$emit('setContactInfo', {name: this.name, email: this.email});

    }
  }
}
</script>

<style lang="scss">
.login-form {
  display: block;
  input, button {
    display: block;
    width: 100%;
    margin: 20px auto;
    padding: 10px;
    border: solid 1px #000;
    font-size: 1.2em;
  }
  button {
    background: #9a4;
    color: #fff;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    &:hover { background: #771; }
  }
}
</style>
